import { clickAttacherServiceFactory } from '../services/click_attacher_service/factories/clickAttacherServiceFactory';

export const attachClickEvents = (dataLayerService, events = []) => {
  if (!dataLayerService || events.length === 0) return;

  const { initSectionWhenUserInteracts } = window.helpers;

  if (!initSectionWhenUserInteracts) return;

  initSectionWhenUserInteracts(document.body, () => {
    const clickAttacherService = clickAttacherServiceFactory(dataLayerService);

    clickAttacherService.attachEvents(events);
  });
};
